// extracted by mini-css-extract-plugin
module.exports = {"linkList":"style-module__linkList___1rsFw","magooshOrigin":"style-module__magooshOrigin___2LtzV","scallopedEdge":"style-module__scallopedEdge___2Iz5E"};